import { RootState } from "src/store";
import { connect } from "react-redux";
import { filterActions } from "../../filter-store";
import { useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { TAttributeOptionsType } from "../../filter-types";

const mapStateToProps = (state: RootState) => ({
  filterState: state.pageReducer.combinedConfiguratorReducer.filterReducer.filterState,
  formData: state.pageReducer.combinedConfiguratorReducer.filterReducer.formData
});

const ownActions = {
  setFormDataAttributes: filterActions.setFormDataAttributes
};

type Props = typeof ownActions & ReturnType<typeof mapStateToProps>;

const AttributesFilterBase = (props: Props) => {
  const { filterState, formData, setFormDataAttributes } = props;

  const attributes = useMemo(() => {
    if (filterState.loading === "has-loaded") {
      return filterState.data.attributes;
    }
    return [];
  }, [filterState]);

  return (
    <>
      {attributes
        .filter(attribute => attribute.values.length > 0)
        .map(attribute => {
          const values = formData.attributes?.find(x => x.id === attribute.id)?.values || [];

          return (
            <Autocomplete
              key={attribute.id}
              value={values.filter(x => x.description && x.id).map((x): TAttributeOptionsType => ({ description: x.description || "", id: x.id || "" }))}
              onChange={(_, values) => {
                setFormDataAttributes({
                  id: attribute.id,
                  name: attribute.name,
                  values
                });
              }}
              getOptionDisabled={option => values.some(selected => selected.id === option.id)}
              size="small"
              multiple
              options={attribute.values.filter(x => x.id && x.description).map((x): TAttributeOptionsType => ({ description: x.description, id: x.id }))}
              getOptionLabel={(option: TAttributeOptionsType) => option.description || ""}
              filterSelectedOptions
              renderInput={params => <TextField {...params} label={attribute.name} />}
            />
          );
        })}
    </>
  );
};

export const AttributesFilter = connect(mapStateToProps, ownActions)(AttributesFilterBase);
